var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-layout"},[_c('div',{staticClass:"page-wr"},[_c('div',{staticClass:"app-lside"},[_c('Avatar'),_c('LeftNav')],1),_c('div',{staticClass:"work-space",attrs:{"id":"work-space"}},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }